import { PayloadAction } from '@reduxjs/toolkit';
import { FormatData, FormatState } from 'src/store/format/types';

const setAvailableFormatsReducer = (state: FormatState, action: PayloadAction<FormatData[]|undefined>) => {
  state.availableFormats = action.payload;
};

export default setAvailableFormatsReducer;
